import { captureException } from "@sentry/react";
import type { IStarAtlasPosterData } from "@stepfinance/dex";
import { createContext, useContext, useEffect, useState } from "react";

type StarAtlasContextState = {
  posterData: IStarAtlasPosterData[];
  refreshContext: () => void;
};

const StarAtlasContext = createContext<StarAtlasContextState>({
  posterData: [],
  refreshContext: () => {},
});

export const StarAtlasContextProvider = ({ children }) => {
  const [nftData, setNFTData] = useState<IStarAtlasPosterData[]>([]);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    const queryStarAtlasAPI = async () => {
      try {
        const resp = await fetch("https://galaxy.staratlas.com/nfts");
        const data: IStarAtlasPosterData[] = await resp.json();
        return data;
      } catch (err) {
        console.error("queryStarAtlasAPI Error:", err);
        captureException(err);
        return [];
      }
    };

    void queryStarAtlasAPI().then(setNFTData);
  }, [refresh]);

  return (
    <StarAtlasContext.Provider
      value={{
        posterData: nftData,
        refreshContext: () => setRefresh((refresh) => refresh + 1),
      }}
    >
      {children}
    </StarAtlasContext.Provider>
  );
};

export const useStarAtlasContext = () => useContext(StarAtlasContext);
